// extracted by mini-css-extract-plugin
export default {"input-amount-to-cart":"InputAmount_input-amount-to-cart__igLO6","input-group":"InputAmount_input-group__52DnI","input-amount-to-cart-sm":"InputAmount_input-amount-to-cart-sm__JQsw3"};